<template>
  <div>
    <div class="filterContainer">
      <div class="filter">
        <span class="is-uppercase filterLabel has-text-weight-bold">{{
          texts.cargoDimensions
        }}</span>
        <div class="field">
          <div class="control">
            <v-select :options="Object.keys(filters)" :value="selectedCargoDimension" v-model="selectedCargoDimension"
              :placeholder="getDimensionPlaceholder" />
          </div>
        </div>
      </div>

      <div class="filter" :class="selectedCargoDimension ? '' : 'inactive'">
        <span class="is-uppercase filterLabel has-text-weight-bold">{{
          texts.axles
        }}</span>
        <div class="field">
          <div class="control">
            <v-select label="axles" :options="selectedCargoDimension
              ? Object.keys(filters[selectedCargoDimension])
              : []
              " :value="selectedAxles" v-model="selectedAxles" :placeholder="getAxlePlaceholder" />
          </div>
        </div>
      </div>

      <div class="filter" :class="selectedCargoDimension && selectedAxles ? '' : 'inactive'">
        <span class="is-uppercase filterLabel has-text-weight-bold">{{
          texts.loadingCapacity
        }}</span>
        <div class="field">
          <div class="control">
            <v-select label="loading_capacity" :options="selectedCargoDimension && selectedAxles
              ? Object.keys(filters[selectedCargoDimension][selectedAxles])
              : []
              " :value="selectedLoadingCapacity" v-model="selectedLoadingCapacity"
              :placeholder="getLoadingCapacityPlaceholder" />
          </div>
        </div>
      </div>
    </div>

    <hr style="background-color: rgba(61, 120, 130, 0.2); opacity: 0.4" />

    <div class="resultAndFilter">
      <div>{{ filteredProducts.length }} {{ productFound }}</div>
      <Pagination :itemsTotal="itemsTotal" :itemsPerPage="itemsPerPage" :currentPage="currentPage"
        :buttonsMax="buttonsMax" :url="this.$route.name" :queryParameter="queryParameter"
        :nextText="pagination.nextText" :previousText="pagination.previousText" :goToText="pagination.goToText"
        :pageText="pagination.pageText" :place="top" />
    </div>

    <div class="product-card products" v-for="(product, index) in slicedProducts" :key="index">
      <h3 class="productName has-text-weight-bold is-centered mb-5">
        {{ product.model }}
      </h3>

      <div class="cardContent">
        <div class="card-details" style="justify-content: space-between;">
          <div class="card-details-inner ">
            <div class="cardData loadingSurface">
              <div class="cardLabel">
                <img class="detailLogo" src="../assets/images/products/rakodasi_felulet.svg" alt="" />
                <div class="detailLabel">
                  {{ product.onlyDeck ? texts.dimension : texts.cargoDimensions }}
                </div>
              </div>
              <div class="detailValue has-text-weight-bold">
                {{ product.cargo_dimensions }}
              </div>
            </div>

            <div v-if="product.axles" class="cardData axes">
              <div class="cardLabel">
                <img class="detailLogo" src="../assets/images/products/tengelyek_szama.svg" alt="" />
                <div class="detailLabel">{{ texts.axles }}</div>
              </div>
              <div class="detailValue has-text-weight-bold">
                {{ product.axles }}
              </div>
            </div>

            <div v-if="product.total_length" class="cardData totalLength">
              <div class="cardLabel">
                <img class="detailLogo" src="../assets/images/products/ossz_hossz.svg" alt="" />
                <div class="detailLabel">{{ texts.totalLength }}</div>
              </div>
              <div class="detailValue has-text-weight-bold">
                {{ product.total_length }}
              </div>
            </div>

            <div v-if="product.maximum_authorized_mass" class="cardData weight">
              <div class="cardLabel">
                <img class="detailLogo" src="../assets/images/products/osszsuly.svg" alt="" />
                <div class="detailLabel">{{ texts.maximumAuthorizedMass }}</div>
              </div>
              <div class="detailValue has-text-weight-bold">
                {{ product.maximum_authorized_mass }}
              </div>
            </div>

            <div v-if="product.own_mass" class="cardData ownMass">
              <div class="cardLabel">
                <img class="detailLogo" src="../assets/images/products/onsuly.svg" alt="" />
                <div class="detailLabel">{{ texts.ownMass }}</div>
              </div>
              <div class="detailValue has-text-weight-bold">
                {{ product.own_mass }}
              </div>
            </div>

            <div class="cardData loadingCapacity">
              <div class="cardLabel">
                <img class="detailLogo" src="../assets/images/products/teherbiras.svg" alt="" />
                <div class="detailLabel">{{ texts.loadingCapacity }}</div>
              </div>
              <div class="detailValue has-text-weight-bold">
                {{ product.loading_capacity }}
              </div>
            </div>

            <div class="cardData price">
              <div class="cardLabel">
                <img class="detailLogo" src="../assets/images/products/ar.svg" alt="" />
                <div class="detailLabel">{{ texts.price }}</div>
              </div>
              <div class="detailValue has-text-weight-bold mr-3" :class="product.newPrice && product.newPrice < product.price
                ? 'oldPrice'
                : ''
                ">
                <p>€ {{ product.price }}<span></span></p>
              </div>
              <div v-if="product.newPrice && product.newPrice < product.price"
                class="detailValue newPrice has-text-weight-bold">
                € {{ product.newPrice }}
              </div>
            </div>
          </div>
          <button class="button is-rounded is-outlined is-primary is-uppercase has-text-weight-bold"
            @click="getSelectedProduct(product)">
            {{ texts.askOffer }}
          </button>
        </div>
        <div class="card-image-container">
          <figure class="image is-5by3">
            <img class="card-image" :src="`${publicPath}${product.img}`" :alt="product.imgAlt" />
          </figure>
        </div>
      </div>
    </div>

    <div class="resultAndFilter">
      <div></div>
      <Pagination ref="paginationComponent" :itemsTotal="itemsTotal" :itemsPerPage="itemsPerPage"
        :currentPage="currentPage" :buttonsMax="buttonsMax" :url="this.$route.name" :queryParameter="queryParameter"
        :nextText="pagination.nextText" :previousText="pagination.previousText" :goToText="pagination.goToText"
        :pageText="pagination.pageText" :place='bottom' />
    </div>
  </div>
</template>

<script>
import Pagination from "./Pagination.vue";
import "vue-select/dist/vue-select.css";

export default {
  name: "PaginationContainer",
  components: {
    Pagination,
  },
  props: ["products", "currentPage", "productFound", "allProducts"],

  data() {
    return {
      itemsPerPage: 9,
      buttonsMax: 5,
      queryParameter: "set",
      url: this.$route.name,
      pagination: {
        nextText: ">",
        previousText: "<",
        goToText: "Go to set",
        pageText: "Set",
      },
      publicPath: process.env.BASE_URL,
      selectedCargoDimension: null,
      selectedAxles: null,
      selectedLoadingCapacity: null,
      selectProduct: {},
      editedFilteredProducts: null,
      bottom: "bottom",
      top: "top"
      // setParameter: null
    };
  },

  computed: {
    slicedProducts() {
      return this.filteredProducts.slice(
        this.itemsPerPage * (this.currentPage - 1),
        this.itemsPerPage * this.currentPage
      );
    },
    filters() {
      let filters = {};
      let cargoDimensions = this.products
        .map((p) => p.cargo_dimensions)
        .filter((x, i, a) => a.indexOf(x) === i);

      cargoDimensions.forEach((cargoDimension) => {
        filters[cargoDimension] = {};
        let axles = this.products
          .filter((product2) => product2.cargo_dimensions == cargoDimension)
          .map((filteredProduct) => filteredProduct.axles)
          .filter((x, i, a) => a.indexOf(x) === i);
        axles.forEach((axle) => {
          filters[cargoDimension][axle] = {};
          let loadingCapacities = this.products
            .filter(
              (product3) =>
                product3.cargo_dimensions == cargoDimension &&
                product3.axles == axle
            )
            .map((filteredProduct) => filteredProduct.loading_capacity)
            .filter((x, i, a) => a.indexOf(x) === i);
          loadingCapacities.forEach((lc) => {
            filters[cargoDimension][axle][lc] = {};
          });
        });
      });
      return filters;
    },
    filteredProducts: {
      get() {
        let products = this.products;

        if (
          this.selectedCargoDimension &&
          this.selectedAxles == null &&
          this.selectedLoadingCapacity == null
        ) {
          products = products.filter(
            (product) => product.cargo_dimensions == this.selectedCargoDimension
          );
        }
        if (
          this.selectedCargoDimension &&
          this.selectedAxles &&
          this.selectedLoadingCapacity == null
        ) {
          products = this.products.filter(
            (product) =>
              product.cargo_dimensions == this.selectedCargoDimension &&
              product.axles == this.selectedAxles
          );
        }
        if (
          this.selectedCargoDimension &&
          this.selectedAxles &&
          this.selectedLoadingCapacity
        ) {
          products = this.products.filter(
            (product) =>
              product.cargo_dimensions == this.selectedCargoDimension &&
              product.axles == this.selectedAxles &&
              product.loading_capacity == this.selectedLoadingCapacity
          );
        }
        return products;
      },
    },
    setParameter() {
      let url_string = window.location.href; //window.location.href
      let url = new URL(url_string);
      return url.searchParams.get("set");
    },
    itemsTotal() {
      return this.filteredProducts.length;
    },
    lastPage() {
      return Math.ceil(this.filteredProducts.length / this.itemsPerPage);
    },
    texts() {
      return this.$t("products.general");
    },
    getDimensionPlaceholder() {
      return this.$t("products.general.chooseDimension");
    },
    getAxlePlaceholder() {
      return this.$t("products.general.chooseAxle");
    },
    getLoadingCapacityPlaceholder() {
      return this.$t("products.general.chooseLoadingCapacity");
    },
  },
  watch: {
    buttonsMax(newValue, oldValue) {
      if (newValue % 2) {
        return;
      }
      if (newValue < oldValue) {
        this.buttonsMax = newValue - 1;
      }
      if (newValue > oldValue) {
        this.buttonsMax = newValue + 1;
      }
    },
    selectedAxles() {
      if (this.currentPage != 1) {
        this.$refs.paginationComponent.goPage(1);
      }

      this.selectedLoadingCapacity = null;
    },
    selectedCargoDimension() {
      if (this.currentPage != 1) {
        this.$refs.paginationComponent.goPage(1);
      }
      this.selectedAxles = null;
      this.selectedLoadingCapacity = null;
    },
    selectedLoadingCapacity() {
      if (this.currentPage != 1) {
        this.$refs.paginationComponent.goPage(1);
      }
    },
  },
  methods: {
    checkLastPage() {
      if (this.currentPage > this.lastPage) {
        this.$router.push({
          name: this.url,
          query: { [this.queryParameter]: this.lastPage },
        });
      }
    },
    getSelectedProduct(selectedProduct) {
      this.$store.dispatch("saveSelectedProduct", selectedProduct);
      this.$router.replace("/" + this.$i18n.locale + "/contact");
    },
  },
};
</script>

<style lang="scss">
.resultAndFilter {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  min-height: 2.3rem;
}

.filterContainer {
  display: flex;

  .filter {
    .filterLabel {
      font-size: 15px;
      line-height: 28px;
    }

    .control {
      min-width: 241px;
      max-width: 250px;
      margin-right: 2rem;
      border-radius: 0.3rem;
      border: 2px solid rgba(61, 120, 130, 0.2);

      .vs__actions {
        cursor: pointer;
      }

      svg {
        fill: #3d7882;
      }

      input {
        height: 40px;
      }
    }
  }

  .filter.inactive {
    opacity: 0.3;
    pointer-events: none;
  }
}

:root {
  --vs-colors--lightest: rgba(61, 120, 130, 0.2);
  --vs-colors--light: rgba(60, 60, 60, 0.5);
  --vs-colors--dark: #333;
  --vs-colors--darkest: rgba(0, 0, 0, 0.15);
  --primary--color: #3d7882;

  /* Search Input */
  --vs-search-input-color: inherit;
  --vs-search-input-placeholder-color: inherit;

  /* Font */
  --vs-font-size: 1rem;
  --vs-line-height: 1.4;

  /* Disabled State */
  --vs-state-disabled-bg: rgb(248, 248, 248);
  --vs-state-disabled-color: var(--vs-colors--light);
  --vs-state-disabled-controls-color: var(--vs-colors--light);
  --vs-state-disabled-cursor: not-allowed;

  /* Borders */
  --vs-border-color: var(--vs-colors--lightest);
  --vs-border-width: 1px;
  --vs-border-style: solid;
  --vs-border-radius: 4px;

  /* Actions: house the component controls */
  --vs-actions-padding: 4px 6px 0 3px;

  /* Component Controls: Clear, Open Indicator */
  --vs-controls-color: var(--vs-colors--light);
  --vs-controls-size: 1;
  --vs-controls--deselect-text-shadow: 0 1px 0 #fff;

  /* Selected */
  --vs-selected-bg: #f0f0f0;
  --vs-selected-color: var(--primary--color);
  --vs-selected-border-color: var(--vs-border-color);
  --vs-selected-border-style: var(--vs-border-style);
  --vs-selected-border-width: var(--vs-border-width);

  /* Dropdown */
  --vs-dropdown-bg: #fff;
  --vs-dropdown-color: inherit;
  --vs-dropdown-z-index: 1000;
  --vs-dropdown-min-width: 160px;
  --vs-dropdown-max-height: 350px;
  --vs-dropdown-box-shadow: 0px 3px 6px 0px var(--vs-colors--darkest);

  /* Options */
  --vs-dropdown-option-bg: #000;
  --vs-dropdown-option-color: var(--vs-dropdown-color);
  --vs-dropdown-option-padding: 3px 20px;

  /* Active State */
  --vs-dropdown-option--active-bg: var(--primary--color);
  --vs-dropdown-option--active-color: #fff;

  /* Deselect State */
  --vs-dropdown-option--deselect-bg: #fb5858;
  --vs-dropdown-option--deselect-color: #fff;

  /* Transitions */
  --vs-transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);
  --vs-transition-duration: 150ms;
}

.product-card.products {
  margin: 3.5rem 0;

  .productName {
    text-align: center;
    margin-bottom: 1.5rem;
    font-size: 28px;
  }

  .cardContent {
    display: flex;
    flex-direction: row;

    border-radius: 16px;

    .card-details {
      border-top: 3px solid rgba(61, 120, 130, 0.2);
      border-left: 3px solid rgba(61, 120, 130, 0.2);
      border-bottom: 3px solid rgba(61, 120, 130, 0.2);
      border-top-left-radius: 1rem;
      border-bottom-left-radius: 1rem;
      width: 40%;
      padding: 30px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: start;

      .cardData {
        display: flex;

        .detailLogo {
          margin-right: 10px;
        }

        .cardLabel {
          width: 244px;
          display: flex;
          font-size: 14px;

          .detailLogo {
            width: 24px;
            height: 24px;
          }

          .detailLabel {
            align-items: center;
            display: flex;
          }
        }

        .detailValue {
          font-size: 18px;
        }

        .detailValue.oldPrice {
          position: relative;
          color: red;

          span {
            border-bottom: 1.5px solid red;
            height: 2px;
            width: 116%;
            position: absolute;
            left: -4px;
            top: 50%;
            -webkit-transform: rotate(-8deg);
            transform: rotate(-8deg);
          }
        }

        .detailValue.newPrice {
          margin-left: 14px;
        }
      }

      .button {
        padding: 23px;
        border: 2px solid;
        margin-top: 2.5rem;
      }

      .card-details-inner {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: fit-content;
        gap: 1rem;
      }
    }

    .card-image-container {
      width: 60%;

      .card-image {
        border-top-right-radius: 1rem;
        border-bottom-right-radius: 1rem;
      }
    }
  }
}

@media (max-width: 1216px) {
  .product-card.products {
    margin: 3.5rem 0;

    .productName {
      text-align: center;
      margin-bottom: 1.5rem;
      font-size: 28px;
    }

    .cardContent {
      display: flex;
      flex-direction: column;

      border-radius: 16px;

      .card-details {
        border-top: none;
        border-left: 3px solid rgba(61, 120, 130, 0.2);
        border-bottom: 3px solid rgba(61, 120, 130, 0.2);
        border-right: 3px solid rgba(61, 120, 130, 0.2);
        border-bottom-left-radius: 1rem;
        border-top-left-radius: 0;
        border-bottom-right-radius: 1rem;
        width: 100%;
        padding: 30px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: start;
        order: 2;
        min-height: unset;

        .cardData {
          display: flex;

          .detailLogo {
            margin-right: 10px;
          }

          .cardLabel {
            width: 170px;
            display: flex;
            font-size: 14px;

            .detailLogo {
              width: 24px;
              height: 24px;
            }
          }

          .detailValue {
            font-size: 18px;
          }
        }

        .button {
          padding: 23px;
          border: 2px solid;
          align-self: center;
        }

      }

      .card-image-container {
        width: 100%;

        .card-image {
          border-bottom-right-radius: 0;
          border-top-left-radius: 1rem;
          border-top-right-radius: 1rem;
        }
      }
    }
  }
}

@media (max-width: 1024px) {
  .product-card.products {
    margin: 3.5rem 0;

    .productName {
      text-align: center;
      margin-bottom: 1.5rem;
      font-size: 28px;
    }

    .cardContent {
      display: flex;
      flex-direction: column;

      border-radius: 16px;

      .card-details {
        border-top: none;
        border-left: 3px solid rgba(61, 120, 130, 0.2);
        border-bottom: 3px solid rgba(61, 120, 130, 0.2);
        border-right: 3px solid rgba(61, 120, 130, 0.2);
        border-bottom-left-radius: 1rem;
        border-top-left-radius: 0;
        border-bottom-right-radius: 1rem;
        width: 100%;
        padding: 30px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: start;
        order: 2;
        min-height: unset;

        .cardData {
          display: flex;

          .detailLogo {
            margin-right: 10px;
          }

          .cardLabel {
            width: 170px;
            display: flex;
            font-size: 14px;

            .detailLogo {
              width: 24px;
              height: 24px;
            }
          }

          .detailValue {
            font-size: 18px;
          }
        }

        .button {
          padding: 23px;
          border: 2px solid;
          align-self: center;
        }
      }

      .card-image-container {
        width: 100%;

        .card-image {
          border-bottom-right-radius: 0;
          border-top-left-radius: 1rem;
          border-top-right-radius: 1rem;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .resultAndFilter {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    min-height: 2.3rem;

    nav {
      margin: 2rem 0 0 0;
    }
  }

  .filterContainer {
    flex-direction: column;
    align-items: center;

    .filter {
      width: 100%;
      margin: 0 0 1rem 0;

      .filterLabel {
        font-size: 15px;
        line-height: 28px;
      }

      .control {
        min-width: 218px;
        max-width: 250px;
        margin-right: 2rem;
        border-radius: 0.3rem;
        border: 2px solid rgba(61, 120, 130, 0.2);
        max-width: unset;
        width: 100%;
        max-width: unset;

        .vs__actions {
          cursor: pointer;
        }

        svg {
          fill: #3d7882;
        }

        input {
          height: 30px;
        }
      }
    }

    .filter.inactive {
      opacity: 0.3;
      pointer-events: none;
    }
  }

  .product-card.products {
    margin: 3.5rem 0;

    .productName {
      text-align: center;
      margin-bottom: 1.5rem;
      font-size: 21px;
    }

    .cardContent {
      display: flex;
      flex-direction: column;

      border-radius: 16px;

      .card-details {
        border-top: none;
        border-left: 3px solid rgba(61, 120, 130, 0.2);
        border-bottom: 3px solid rgba(61, 120, 130, 0.2);
        border-right: 3px solid rgba(61, 120, 130, 0.2);
        border-bottom-left-radius: 1rem;
        border-top-left-radius: 0;
        border-bottom-right-radius: 1rem;
        width: 100%;
        padding: 16px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: start;
        order: 2;
        min-height: unset;

        .cardData {
          display: flex;

          .detailLogo {
            margin-right: 10px;
          }

          .cardLabel {
            width: 170px;
            display: flex;
            font-size: 12px;

            .detailLogo {
              width: 16px;
              height: 16px;
            }
          }

          .detailValue {
            font-size: 14px;
          }
        }

        .button {
          padding: 18px;
          border: 2px solid;
          font-size: 14px;
          align-self: center;
        }
      }

      .card-image-container {
        width: 100%;

        .card-image {
          border-bottom-right-radius: 0;
          border-top-left-radius: 1rem;
          border-top-right-radius: 1rem;
        }
      }
    }
  }
}

@media (max-width: 400px) {
  .product-card.products {
    margin: 3.5rem 0;

    .productName {
      text-align: center;
      margin-bottom: 1.5rem;
      font-size: 21px;
    }

    .cardContent {
      display: flex;
      flex-direction: column;

      border-radius: 16px;

      .card-details {
        border-top: none;
        border-left: 3px solid rgba(61, 120, 130, 0.2);
        border-bottom: 3px solid rgba(61, 120, 130, 0.2);
        border-right: 3px solid rgba(61, 120, 130, 0.2);
        border-bottom-left-radius: 1rem;
        border-top-left-radius: 0;
        border-bottom-right-radius: 1rem;
        width: 100%;
        padding: 16px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: start;
        order: 2;
        min-height: unset;

        .cardData {
          display: flex;

          .detailLogo {
            margin-right: 10px;
          }

          .cardLabel {
            width: 140px;
            display: flex;
            font-size: 12px;

            .detailLogo {
              width: 16px;
              height: 16px;
            }
          }

          .detailValue {
            font-size: 14px;
          }
        }

        .button {
          padding: 18px;
          border: 2px solid;
          font-size: 14px;
          align-self: center;
        }
      }

      .card-image-container {
        width: 100%;

        .card-image {
          border-bottom-right-radius: 0;
          border-top-left-radius: 1rem;
          border-top-right-radius: 1rem;
        }
      }
    }
  }
}
</style>
